<template lang="pug">
  .login.login-pc(:class='isShowLogin ? "animated fadeIn" : "animated fadeOut" ')
    //- 登录
    .login-wrap.pos-r
      closeCtrl(@on-close='toggleLogin')
      h2.title 登录
      .login-body
        .field
          //- p.text 用户名
          .input-box.pos-r
            .icon
              i.iconfont.icon-phone
            input(v-model="username", type="text", placeholder="请输入用户名")
        .field
          //- p.text 密码
          .input-box.pos-r
            .icon
              i.iconfont.icon-lock-outline
            input(v-model="password", type="password", placeholder="请输入密码", @keyup.enter='handleLogin')

        .field.clearfix.mt10
          a.link.fl(href="javascript:;", @click="switchSignUp") 用户注册
          a.link.fr(href="javascript:;", @click='findPassword') 忘记密码

      .login-foot
        span.login-btn(@click="handleLogin") 登陆
</template>

<script>
import loginMixin from '@/mixins/login'
export default {
  name: 'loginPc',
  mixins: [loginMixin],
}
</script>

<style lang="stylus" scoped>
@import '~assets/styles/mixins.styl'
@import '~assets/styles/colors.styl'
@import '~assets/styles/variables.styl'
$text-color = #666

.login-pc
  pos-center()
  width: 400px
  padding: 20px
  background-color: rgba($--color-white, .3)
  z-index: $--zindex-high
  .login-wrap
    padding: 30px
    background-color: $--color-white
    .title
      color: $--font-title-color
      font-size: 24px

    .login-body
      .field
        .input-box
          margin-top: 30px
          border: 1px solid #d9d9d9
          border-radius: 2px
          .icon
            position: absolute
            left: 0
            top: 0
            height: 100%
            width: 40px
            line-height: 40px
            color: $text-color
            border-right: 1px solid #d9d9d9
            background-color: #fafafa
            text-align: center
            i
              font-size: 24px
          input
            width: 100%
            font-size: 16px
            padding: 5px 10px 5px 55px
            line-height: 30px
            box-sizing: border-box
            background-color: $--color-white
            color: $text-color
            outline: none
            border: none
            &::-webkit-input-placeholder
              color: $text-color
              font-size: 14px
        .link
          color: $--color-blue
          font-size: 14px
    .login-btn
      display: block
      letter-spacing: 1.5px
      border-radius: 4px
      padding: 12px 39px
      margin-top: 2em
      font-size: 15px
      background-color: $--color-blue
      color: $--color-white
      font-weight: bold
      text-align: center
      cursor: pointer
// .login-pc
//   pos-center()
//   width: 800px
//   padding: 30px 20px
//   box-sizing: border-box
//   background-color: rgba($--color-white, .8)
//   z-index: $--zindex-high
//   .login-wrap
//     .title
//       color: $--font-title-color
//       font-size: 25px
//       text-align: left
//       margin-bottom: 1em
//       .link
//         font-size: 15px
//         color: #ff9800
//         margin-left: 10px
//         font-weight: 500
//     .field
//       position: relative
//       padding: 10px 0
//       .link
//         color: $--color-blue
//         font-size: 15px
//         &:hover
//           color: $theme-color
//       .text
//         color: $--font-title-color
//         font-size: 15px
//         margin: 0px 0px 4px
//         letter-spacing: 1px
//         text-align: left
//       .input-box
//         .icon
//           position: absolute
//           left: 10px
//           top: 0
//           height: 100%
//           width: 20px
//           line-height: 40px
//           color: #fff
//           text-align: center
//           i
//             font-size: 24px
//         input
//           width: 100%
//           font-size: 16px
//           padding: 10px 10px 9px 45px
//           line-height: 20px
//           color: $--font-color
//           background: rgba($--color-white, .6)
//           box-sizing: border-box
//           outline: none
//           border: none
//           &::-webkit-input-placeholder
//             color: $--font-color
//             font-size: 14px
//       .login-btn
//         display: block
//         letter-spacing: 1.5px
//         border-radius: 4px
//         padding: 12px 39px
//         margin-top: 2em
//         font-size: 15px
//         background: #00c6d7
//         color: $--color-white
//         font-weight: bold
//         text-align: center
//         cursor: pointer
</style>
